<form [formGroup]="formGroup">
  <h1 *ngIf="!!data.title" mat-dialog-title>{{ 'increaseItemCountDialog.title' | translate }}</h1>
  <mat-dialog-content>
    <p>
      {{ 'increaseItemCountDialog.text' | translate }}
    </p>

    <div class="item-count-row">
      <mat-form-field>
        <input readonly matNativeControl type="number" formControlName="itemCount"
               min="{{ minItemCount }}" max="{{ maxItemCount }}" step="1">
      </mat-form-field>
      <button mat-icon-button (click)="onDecrease()">
        <mat-icon>exposure_minus_1</mat-icon>
      </button>
      <button mat-icon-button (click)="onIncrease()">
        <mat-icon>exposure_plus_1</mat-icon>
      </button>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">{{ 'cancel' | translate }}</button>
    <button mat-flat-button color="primary"
            [disabled]="formGroup.invalid"
            (click)="onConfirm()">{{ 'confirm' | translate  }}</button>
  </mat-dialog-actions>
</form>
